import {
  ProviderType,
  ResourceType,
} from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";
import { resourceGroups } from "../../../../utils/constants/resources/resourceGroups";
import { resourceTypeDataEmsSelector } from "../resource-type-data/resourceTypeDataEmsSelector";

export const resourceGroupEmsSelector = (
  state: RootState,
  provider: ProviderType,
  resourceGroupKey: ResourceType,
  resourceTypesToSkip?: Map<ResourceType, boolean>,
) => {
  const resourceGroupTypes = resourceGroups
    .get(provider)
    ?.find((resourceGroup) => resourceGroup.value === resourceGroupKey)
    ?.resourceTypes.filter(
      (resourceType) => !resourceTypesToSkip?.get(resourceType),
    );

  return (
    resourceGroupTypes
      ?.map((resourceType) => resourceTypeDataEmsSelector(state, resourceType))
      ?.reduce((acc, currentValue) => acc + currentValue, 0) ?? 0
  );
};
